import { formatMetricValue } from '../../lib/reportNew/formatNew'
import { colorAt, makeColorAt } from './chart-themeNew'

/**
 * Vista de indicador: valor agregado grande y, si el widget define un
 * desglose, las principales aportaciones con su porcentaje.
 */
export function KpiView({ value, format, label, breakdown = [] }) {
  const total = breakdown.reduce((acc, item) => acc + item.__total, 0)

  return (
    <div className="flex flex-col gap-3">
      <p className="text-[30px] leading-none font-semibold tracking-tight text-foreground tabular-nums">
        {formatMetricValue(value, { ...format, compact: Math.abs(value) >= 100000 })}
      </p>
      <p className="text-[12px] text-muted-foreground">{label}</p>

      {breakdown.length > 0 && (
        <ul className="flex flex-col gap-1.5 border-t border-border pt-2.5">
          {breakdown.map((item, index) => (
            <li key={item.__key} className="flex items-center justify-between gap-2 text-[12.5px]">
              <span className="flex min-w-0 items-center gap-1.5">
                <span
                  aria-hidden="true"
                  className="h-2 w-2 shrink-0 rounded-full"
                  style={{ backgroundColor: colorAt(index) }}
                />
                <span className="truncate text-muted-foreground">{item.name}</span>
              </span>
              <span className="shrink-0 font-medium tabular-nums text-foreground">
                {total ? `${((item.__total / total) * 100).toFixed(1)}%` : '—'}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
